<div class="layout py-4 md:py-12 bg-beige">
  <div class="grid grid-cols-1 md:grid-cols-2 auto-rows-fr gap-x-4 gap-y-8 mt-4 md:mt-8">
    @for (card of cards; track card.link) {
      <div [routerLink]="['/', 'nos-engagements', card.link]"
           class="bg-white rounded-lg p-2 h-full flex flex-col cursor-pointer group">
        <div class="bg-white h-full rounded-lg p-6 group flex flex-col justify-between">
          <div class="w-full relative">
            <div class="overflow-hidden relative rounded-lg aspect-[11/6]">
              <img class="object-cover group-hover:scale-110 transition-all duration-500"
                   fill=""
                   [ngSrc]="card.image"
                   sizes="(max-width: 768) 100vw, (max-width: 1224) 25vw, 20vw">
            </div>
          </div>
          <div class="flex flex-col md:flex-row md:mt-4 justify-between items-center gap-4">
            <h3
              class="text-xl text-bleuCaliceo-300 uppercase font-semibold text-start">{{ card.text | translate }}</h3>
            <a [routerLink]="['/', 'nos-engagements', card.link]"
               appHoverGradient
               class="w-auto px-4 md:px-6 text-start text-sm min-w-32 hidden md:inline">
              {{ 'learnMore' | translate }}
            </a>
          </div>
        </div>
      </div>
    }
  </div>
</div>
